import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Modal } from '@app/src/common/Modal';
import { Icon } from '@app/src/common/Icon';
import {
  ListOptions,
  RadioInputWrapper,
  ModalTitle,
  Content,
  LoaderWrapper,
  IconVignetteWrapper,
  Name
} from './styled';

interface Props {
  handleChangeRadioInput?: Function;
  showFirstItems?: number;
  className?: string;
  show: boolean;
  handleClickCloseModal?: Function;
  modalTitle: string;
  handleKeyDown?: Function;
  colorTheme?: string;
  initialValue?: string;
  origin?: boolean;
}

export const VignetteOptionModal: React.FC<Props> = ({
  showFirstItems,
  className,
  show,
  handleClickCloseModal,
  modalTitle,
  handleKeyDown,
  colorTheme,
  handleChangeRadioInput,
  initialValue,
  origin
}) => {
  const [ activeItem, setActiveItem ] = useState(null);
  const vignettes = useSelector(state => state.vignette.data);
  const isLoading = useSelector(state => state.vignette.isFetching);
  const isError = useSelector(state => state.vignette.error);

  const handleChangeOption = (_value, index, item) => {
    setActiveItem(index);
    handleChangeRadioInput && handleChangeRadioInput(item);
  };

  const closeModal = useCallback(() => {
    handleClickCloseModal && handleClickCloseModal(vignettes[activeItem]);
  }, [vignettes, activeItem]);

  useEffect(() => {
    if (origin) {
      console.log('clicked checkbox')
      setActiveItem(-1);
    }
  }, [origin]);

  useEffect(() => {
    if (initialValue && vignettes && vignettes.length > 0) {
      vignettes.map((item, index) => {
        if (item.name === initialValue) {
          setActiveItem(index);
        }
      })
    }
  }, [vignettes, initialValue]);

  return(
  <Modal
    show={show}
    closeModal={closeModal}
    customBody
  >
    <Content>
      {
        (isLoading || isError) ?
          <LoaderWrapper>
            <Icon data-name='icon-circle' fill='#ccc' width={'17'} height={'17'} />
          </LoaderWrapper>
        :
        <React.Fragment>
          <ModalTitle>{modalTitle}</ModalTitle>
          <ListOptions
            className={className}
            showFirstItems={showFirstItems}
            onKeyDown={handleKeyDown}
          >
            {
              vignettes && vignettes.length > 0 && vignettes.map((element, index) => (
                <RadioInputWrapper
                  colorActive={colorTheme}
                  name="optionVignette"
                  key={index}
                  tabIndex="-1"
                  activeSuggestion={index === activeItem}
                  value={element.id}
                  contentLeft
                  checked={index === activeItem}
                  handleChange={(value) => handleChangeOption(value, index, element)}
                >
                  <IconVignetteWrapper>
                    <Icon data-name="icon-check-vignette" width="17" height="17" fill="#ff0000" />
                  </IconVignetteWrapper>
                  <Name>{element.name}</Name>
                </RadioInputWrapper>
              ))
            }
          </ListOptions>
        </React.Fragment>
      }
    </Content>
  </Modal>
)};
